// @flow

import Product from './Product';
import type { ApiResponseProduct } from '../types/ApiResponseProduct';

const makeProductFromApiResponse = (responseProduct: ApiResponseProduct): Product => new Product(responseProduct);

export default makeProductFromApiResponse;
